import { useTranslation } from 'react-i18next';
import {
  ElementsButton,
  SideOverHeading,
  SideOverHeaderNew,
  SideOverHeaderNewProps,
  SideOverFooter,
} from '../components';
import {
  StandardPersonalPropertyItemForm,
  StandardPersonalPropertyItemFormVisibilityOptions,
} from '../../PersonalPropertyItem/components';
import { usePersonalPropertyItemForm } from '../../PersonalPropertyItem/hooks';
import { MDTailwindMinPixelBreakpointWidth } from '../../util';
import { useWindowSize } from 'react-use';

export interface CreatePersonalPropertyItemFormSideOverPageProps extends Pick<SideOverHeaderNewProps, 'exit'> {
  firmID: string;
  clientID: string;
  householdID: string;
  visibilityOptions?: StandardPersonalPropertyItemFormVisibilityOptions;
  isLoading?: boolean;
  sideOverHeaderChildren?: React.ReactNode;
  usePersonalPropertyItemFormReturn: ReturnType<typeof usePersonalPropertyItemForm>;
}

export function CreatePersonalPropertyItemFormSideOverPage({
  exit,
  firmID,
  clientID,
  isLoading,
  visibilityOptions,
  sideOverHeaderChildren,
  usePersonalPropertyItemFormReturn,
}: CreatePersonalPropertyItemFormSideOverPageProps) {
  const { t: tCommon } = useTranslation('common');
  const { width: windowWidth } = useWindowSize();

  return (
    <>
      <SideOverHeaderNew exit={exit} withShadow className="md:!px-4" exitText={tCommon('cancel')}>
        {sideOverHeaderChildren}
      </SideOverHeaderNew>
      <div className="md:px-10 px-4">
        <SideOverHeading heading={tCommon('personal-property-item')} />
        <StandardPersonalPropertyItemForm
          firmID={firmID}
          clientID={clientID}
          className="mb-28 md:mb-36"
          visibilityOptions={visibilityOptions}
          usePersonalPropertyItemFormReturn={usePersonalPropertyItemFormReturn}
        >
          <SideOverFooter>
            <ElementsButton
              icon="check"
              iconPosition="left"
              isLoading={isLoading}
              label={tCommon('save')}
              size={windowWidth < MDTailwindMinPixelBreakpointWidth ? 'small' : 'large'}
            />
          </SideOverFooter>
        </StandardPersonalPropertyItemForm>
      </div>
    </>
  );
}
